import React from 'react';
import { HeroSection } from './components/HeroSection';
import { AudienceSection } from './components/AudienceSection';
import { SolutionSection } from './components/SolutionSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { ClosingSection } from './components/ClosingSection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#0f172a]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <AudienceSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <TestimonialsSection data-id="element-4" />
      <BonusesSection data-id="element-5" />
      <PricingSection data-id="element-6" />
      <ClosingSection data-id="element-7" />
      <Footer data-id="element-8" />
      <SocialProofPopup data-id="element-9" />
    </div>;
}